import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Signposts from './components/Signposts';
import AppDownloadSection from './components/AppDownloadSection';

/*
 * /getstarted — the entry page. 4 Sep 2026.
 *
 * This file used to be the individuals page; that content is now
 * IndividualsPage.js and this is a router. Three sections: what this is, where
 * to go, and how to start. No argument, no proof, no calculator — everything
 * that persuades lives on the page the reader is sent to.
 *
 * WHY IT IS NOT THE HOMEPAGE. The homepage leads with the employer case,
 * because employers are the ICP and that page has to sell. This one leads with
 * nothing, because the reader did not arrive looking for a pitch: they scanned
 * something, followed a link from the app, or were sent here. A page that opens
 * by selling to a different audience than the reader is one they bounce off.
 *
 * It only earns its place while it stays this thin. The moment it starts
 * explaining or persuading it becomes a worse homepage and should be retired.
 *
 * The hero is single-column and carries no visual on purpose: one would make
 * this look like a destination rather than a fork in the road.
 */

const GetStartedPage = () => {
    useEffect(() => {
        document.title = 'Get started | PhysioActivity';
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute('content', 'Whether you are covered at work, looking for yourself, or work in it: start here.');
    }, []);

    return (
    <div className="pa2">

        <section className="hero" id="top">
            <div className="wrap">
                <h1 className="on-dark">
                    <span className="setup">Start here.</span>
                    <span className="payoff">Wherever you have come from.</span>
                </h1>
                <p className="lede">
                    PhysioActivity reads how you move from the phone you already carry, and a
                    registered physiotherapist builds a programme around it. Same platform
                    whoever you are.
                </p>
                <p className="nerve">
                    You don&rsquo;t need an injury, a referral or a watch to begin.
                </p>
                <div className="cta-row">
                    <a className="btn btn-t" href="#get">Get the app</a>
                    <a className="btn btn-o" href="#who">Show me my page</a>
                </div>
            </div>
        </section>

        <Signposts>
            <p className="quiet">
                Two pieces sit underneath all four:{' '}
                <Link to="/steadystride">SteadyStride</Link>, the app, and{' '}
                <Link to="/cmpx">CMPX</Link>, the portal the data lands in.
            </p>
        </Signposts>

        <section className="s-promise" id="get">
            <div className="wrap">
                <h2 className="on-dark">
                    <span className="setup">Or just start.</span>
                    <span className="payoff">You can work the rest out later.</span>
                </h2>
                <p className="lede">
                    Download the app, and your first programme is built from how you actually
                    move this week. If your employer covers it, you will have a code to enter.
                </p>
                <AppDownloadSection appId="steadystride" />
                <p className="quiet">
                    Not sure where you fit? <Link to="/contact?who=individual">Talk to us</Link>.
                </p>
            </div>
        </section>

    </div>
    );
};

export default GetStartedPage;
